import React, { useEffect, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import axios from "axios";
import { apiMainUser } from "../../../utils/constant";
import { useDispatch } from "react-redux";
import { ADD_MESSAGE } from "../../../utils/redux/messageSlice";
import { useSelector } from "react-redux";

const ChatInput = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const emojiPickerRef = useRef(null);

  const onEmojiClick = (emoji) => {
    setInputValue((prevInput) => prevInput + emoji.emoji);
    setShowPicker(false);
  };

  const dispatch = useDispatch();

  const isSmallScreen = window.innerWidth <= 500;

  const { selectedRoomIdMessages, selectedRoomId } = useSelector(
    (state) => state.Message
  );

  const handleClickOutside = (event) => {
    if (
      emojiPickerRef.current &&
      !emojiPickerRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const currentDate = new Date();

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Asia/Kolkata",
      timeZoneName: "short",
    };
    const isoFormattedDate = currentDate.toLocaleString("en-US", options);

    // logic should change based on user type

    try {
      const newMessage = {
        message_type: "",
        message: inputValue,
        createdon: isoFormattedDate,
        lead_event_id: props.lead_events,
        updatedon: isoFormattedDate,
        message_from: props.type === 0 ? 0 : 1,
        you: 1,
      };

      console.log("new message ==> ", { ...newMessage });

      // props.updateMessageArray(newMessage);

      if (props.type != 1)
        dispatch(ADD_MESSAGE({ roomId: selectedRoomId, message: newMessage }));

      const payload = {
        lead_event_id: props.lead_events,
        message: inputValue,
        // chat_room_id: props.room_id,

        chat_room_id: selectedRoomId,
        //selected room_id from dispatch
      };

      // Call your API here
      const response = await axios.post(apiMainUser + "create_chat", payload, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      console.log("API Response:", response.data);
      // props.updateMessageArray(newMessage);
      setInputValue("");
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <div
      className="emoji-picker-div"
      ref={emojiPickerRef}
      style={{
        paddingInline: ".5rem",
        position: isSmallScreen ? "fixed" : "absolute",
        bottom: 0,
      }}
    >
      <form
        onSubmit={onSubmit}
        className="message-form"
        style={{ position: "relative" }}
      >
        <div
          className="emoji-picker-wrapper flex"
          style={{ position: "relative" }}
        >
          <button
            type="button"
            onClick={() => setShowPicker((prev) => !prev)}
            className="emoji-button pointer"
          >
            😀
          </button>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Start typing..."
            className="message-input"
          />
          <button type="submit" className="send-btn pointer">
            <img src="/assets/img/sendIcon.png" alt="" />
          </button>
        </div>
        {showPicker && (
          <EmojiPicker
            style={{ position: "absolute", bottom: "0rem" }}
            onEmojiClick={onEmojiClick}
          />
        )}
      </form>
    </div>
  );
};

export default ChatInput;
